import React from 'react';

import { searchRegexLanguageParser, SearchRegexQueryParserErrorCode } from './parser';
import { SearchQueryTerm } from './types';

type RegexpQueryValidationResult = {
  parsedQuery: SearchQueryTerm[];
  errorCode?: SearchRegexQueryParserErrorCode;
  isValid: boolean;
};

export function useRegexpQueryValidation(query: string): RegexpQueryValidationResult {
  return React.useMemo(() => {
    const result = searchRegexLanguageParser.parse(query);

    return {
      parsedQuery: result.query,
      errorCode: result.errorCode,
      isValid: result.status === 'valid',
    };
  }, [query]);
}
